<template>
  <div>
    <div style="overflow-x: auto; white-space: nowrap">
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'today'"
        :color="currentFilter == 'today' ? 'primary' : 'grey'"
        small
        @click="changeDate('today')"
        v-if="!itemsHide.includes('today')"
        >{{ $t('today') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'yesterday'"
        :color="currentFilter == 'yesterday' ? 'primary' : 'grey'"
        small
        @click="changeDate('yesterday')"
        v-if="!itemsHide.includes('yesterday')"
        >{{ $t('yesterday') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_3_days'"
        :color="currentFilter == 'last_3_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_3_days')"
        v-if="!itemsHide.includes('last_3_days')"
        >{{ $t('last {day} days', { day: 3 }) }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_7_days'"
        :color="currentFilter == 'last_7_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_7_days')"
        v-if="!itemsHide.includes('last_7_days')"
        >{{ $t('last {day} days', { day: 7 }) }}</v-btn
      >

      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_15_days'"
        :color="currentFilter == 'last_15_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_15_days')"
        v-if="!itemsHide.includes('last_15_days')"
        >{{ $t('last {day} days', { day: 15 }) }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'this_month'"
        :color="currentFilter == 'this_month' ? 'primary' : 'grey'"
        small
        @click="changeDate('this_month')"
        v-if="!itemsHide.includes('this_month')"
        >{{ $t('this month') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'this_year'"
        :color="currentFilter == 'this_year' ? 'primary' : 'grey'"
        small
        @click="changeDate('this_year')"
        v-if="!itemsHide.includes('this_year')"
        >{{ $t('this year') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_90_day'"
        :color="currentFilter == 'last_90_day' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_90_day')"
        v-if="!itemsHide.includes('last_90_day')"
        >{{ $t('last 90 days') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_month'"
        :color="currentFilter == 'last_month' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_month')"
        v-if="!itemsHide.includes('last_month')"
        >{{ $t('last 30 days') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_365_day'"
        :color="currentFilter == 'last_365_day' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_365_day')"
        v-if="!itemsHide.includes('last_365_day')"
        >{{ $t('last 365 days') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'custom_date'"
        :color="currentFilter == 'custom_date' ? 'primary' : 'grey'"
        small
        @click="changeDate('custom_date')"
        v-if="!itemsHide.includes('custom_date')"
        >{{ $t('Custom Date') }}</v-btn
      >
    </div>

    <div class v-if="currentFilter == 'custom_date' || currentFilter == 'custom_time'">
      <v-layout wrap>
        <v-flex xs12 sm6 class="px-1">
          <span class="order_summary_datepicker">{{ $t('from') }}:</span>
          <v-layout wrap row class="mb-2">
            <v-flex :xs12="!showTime" :xs8="showTime" class="form-control">
              <datepicker
                color="primary"
                v-model="selectedDate.start"
                @selected="onSelectedStartDate"
              ></datepicker>
            </v-flex>
            <v-flex v-if="showTime" xs4 class="form-control px-1">
              <time-picker v-model="starttime" full-width></time-picker>
              <!-- <v-dialog
                ref="starttime"
                v-model="showStartTimeDialog"
                :return-value.sync="starttime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <input type="text" readonly v-on="on" placeholder="00:00" v-model="starttime" />
                  </div>
                </template>
                <time-picker v-if="showStartTimeDialog" v-model="starttime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showStartTimeDialog = false">
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.starttime.save(starttime)
                      showStartTimeDialog = false
                      onSelectedStartDate(selectedDate.end)
                    "
                    >{{ $t('Confirm') }}</v-btn
                  >
                </time-picker>
              </v-dialog> -->
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 class="px-1">
          <span class="order_summary_datepicker" style="margin-bottom: 10px">{{ $t('to') }}:</span>
          <v-layout wrap row class="mb-2">
            <v-flex :xs12="!showTime" :xs8="showTime" class="form-control">
              <datepicker
                v-model="selectedDate.end"
                style
                @selected="onSelectedEndDate"
              ></datepicker>
            </v-flex>
            <v-flex v-if="showTime" xs4 class="form-control px-1">
              <time-picker v-model="endtime" full-width></time-picker>
              <!-- <v-dialog
                ref="endtime"
                v-model="showEndTimeDialog"
                :return-value.sync="endtime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <input type="text" readonly v-on="on" placeholder="00:00" v-model="endtime" />
                  </div>
                </template>
                <time-picker v-if="showEndTimeDialog" v-model="endtime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showEndTimeDialog = false">
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.endtime.save(endtime)
                      showEndTimeDialog = false
                      onSelectedEndDate(selectedDate.end)
                    "
                    >{{ $t('Confirm') }}</v-btn
                  >
                </time-picker>
              </v-dialog> -->
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn color="primary" @click="loadData" small>{{ $t('Search') }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import TimePicker from '@/components/elements/TimePicker.vue'
export default {
  props: {
    value: {
      default: undefined
    },
    defaultFilter: {
      default: 'last_7_days'
    },
    showTime: {
      default: false
    },
    itemsHide: {
      type: Boolean,
      default: () => ['last_90_day']
    }
  },
  components: { datepicker, TimePicker },

  data: function() {
    return {
      showpremium: true,
      selectedDate: this.value,
      currentFilter: this.defaultFilter,
      showStartDate: false,
      showEndDate: false,
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59'
    }
  },
  computed: {
    isPremium() {
      return this.$store.getters.getPackage == 'premium'
    },
    ...mapGetters(['selectedBot'])
  },
  methods: {
    clearCurrentFilter() {
      this.currentFilter = ''
    },
    emitDateTime() {
      var vm = this
      let data = {
        start:
          dayjs(vm.selectedDate.start).format('YYYY-MM-DD') +
          (vm.starttime && vm.showTime ? ' ' + vm.starttime : ' 00:00'),
        end:
          dayjs(vm.selectedDate.end).format('YYYY-MM-DD') +
          (vm.endtime && vm.showTime ? ' ' + vm.endtime : ' 23:59')
      }
      vm.$emit('onSelected', data)
      vm.$emit('input', data)
      vm.$emit('changeDate', data)
    },
    changeDate: function(value) {
      var vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = dayjs().format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'yesterday':
          vm.selectedDate.start = dayjs()
            .subtract(1, 'days')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs()
            .subtract(1, 'days')
            .format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'this_month':
          vm.selectedDate.start = dayjs()
            .startOf('month')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs()
            .endOf('month')
            .format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'last_3_days':
          vm.selectedDate.start = dayjs()
            .subtract(3, 'days')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'last_7_days':
          vm.selectedDate.start = dayjs()
            .subtract(7, 'days')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'last_15_days':
          vm.selectedDate.start = dayjs()
            .subtract(15, 'days')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'last_month':
          vm.selectedDate.start = dayjs()
            .subtract(1, 'months')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'this_month':
          vm.selectedDate.start = dayjs()
            .startOf('month')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs()
            .endOf('month')
            .format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break
        case 'this_year':
          vm.selectedDate.start = dayjs()
            .startOf('year')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs()
            .endOf('year')
            .format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'last_90_days':
          vm.selectedDate.start = dayjs()
            .subtract(90, 'days')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'last_365_day':
          vm.selectedDate.start = dayjs()
            .subtract(365, 'days')
            .format('YYYY-MM-DD 00:00')
          vm.selectedDate.end = dayjs().format('YYYY-MM-DD 23:59')
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.emitDateTime()
          break

        case 'custom_date':
          break
      }
    },
    onSelectedStartDate: function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (dayjs(vm.selectedDate.end).isBefore(value)) {
        vm.selectedDate.end = value
      }
      vm.selectedDate.start = value
      vm.showStartDate = false
    },
    onSelectedEndDate: function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (dayjs(value).isBefore(vm.selectedDate.start)) {
        vm.selectedDate.start = value
      }
      vm.selectedDate.end = value
      vm.showEndDate = false
    },
    loadData() {
      this.emitDateTime()
    }
  },
  watch: {
    value: function(newVal) {
      this.selectedDate = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/DateFilter.vue